import S from 's-js';
import { Entrypoints } from 'core/app/entrypoints';
import { IAjax } from 'lib/Ajax';
import TZDate from 'lib/TZDate';
import { PCUser } from 'data/models/PCUser';
import { PersonProfilePopupResponse, PersonProfilePopupResponseData } from 'data/models/PersonProfilePopupResponse';
import { PhoneNumber, PhoneNumberData } from 'data/models/PhoneNumber';
import { PhoneNumberKind } from 'server/enums/PhoneNumberKind';
import { PhoneNumber as PhoneNumberViewModel } from 'portcall/phonenumber/model';
import { PersonProfilePopupCache } from './cache';

export interface PersonProfilePopupParams {
    id : number;
    onHidePopup : () => void;
}

export interface PCUserViewModel {
    Model : PCUser;
    MainNumber : () => PhoneNumberViewModel | null;
    OtherNumbers : () => PhoneNumberViewModel[];
    ShowMoreNumbers : () => boolean;
    ToggleMoreNumbers : () => void;
}

export function PersonProfilePopup(
    entrypoints : Entrypoints,
    ajax : IAjax,
    queryCache : PersonProfilePopupCache,
    phoneNumberModel : (pn : PhoneNumber, deleteFn : () => void) => PhoneNumberViewModel,
    { id, onHidePopup } : PersonProfilePopupParams
) {
    let model = queryCache.PersonProfilePopupResponses.update1(null, { UserId: id }),
        url = entrypoints.PersonProfilePopup({ Id: id }),
        request = ajax.Url<PersonProfilePopupResponseData>(url).Get(),
        user = S(() => model.PCUser() && PCUserViewModel(model.PCUser()!));

    request.done(data => {
        queryCache.PersonProfilePopupResponses.update1(request.Date, data);
    });

    return {
        UserId : id,
        Model: model,
        User: user,
        HidePopup: onHidePopup
    };

    function PCUserViewModel(user : PCUser) : PCUserViewModel {
        let showMoreNumbers = S.data(false),
            mainNumber = S(() => user.MainPhoneNumber() && phoneNumberModel(user.MainPhoneNumber()!, () => {})),
            otherNumbers = S(() => user.OtherPhoneNumbers().map(p => phoneNumberModel(p, () => {})));

        return {
            Model: user,
            MainNumber: mainNumber,
            OtherNumbers: otherNumbers,
            ShowMoreNumbers: showMoreNumbers,
            ToggleMoreNumbers: ToggleMoreNumbers
        };

        function ToggleMoreNumbers() {
            showMoreNumbers(!showMoreNumbers());
        }
    }
}
export type PersonProfilePopup = ReturnType<typeof PersonProfilePopup>;


// WEBPACK FOOTER //
// ./apps/portcall/personprofilepopup/model.ts